<template>
  <section class="dashboard">
    <Header/>
    <div class="dashboard__main_container">
      <div class="dashboard__filters">
        <div class="dashboard__select_container">
          <span class="dashboard__filter_icon"><BuildingIcon color="#74787b"/></span>
          <v-select
              solo
              flat
              item-text="name"
              item-value="id"
              @input="updateSelectedLocation"
              v-model="selectedLocation"
              :items="locations">
          </v-select>
        </div>
        <div class="dashboard__select_container">
          <span class="dashboard__filter_icon"><UsersIcon color="#74787b"/></span>
          <v-select
              solo
              flat
              item-text="name"
              item-value="id"
              @input="updateSelectedUser"
              v-model="selectedUser"
              :items="users">
          </v-select>
        </div>
        <div class="dashboard__select_container">
          <span class="dashboard__filter_icon"><CalendarIcon color="#74787b"/></span>
          <VueDatePicker @input="updateDateRange" no-calendar-icon v-model="dateRange" range label="Rango de Fechas" format="DD/MM/YYYY"><p>{{ dateRange }}</p></VueDatePicker>
          <span v-if="dateRange" @click="clearDateRange" class="dashboard__clear_datepicker"><CancelIcon/></span>
        </div>
      </div>
      <section class="dashboard__general_container">
        <div class="dashboard__stats_container" v-if="generalStats">
          <div class="dashboard__stats_box dashboard__stats_box--created">
            <h6>Invitaciones Creadas</h6>
            <br/>
            <p>{{ generalStats.created }}</p>
          </div>
          <div class="dashboard__stats_box dashboard__stats_box--approved">
            <h6>Invitaciones Aprobadas</h6>
            <br/>
            <p>{{ generalStats.approved }}</p>
          </div>
          <div class="dashboard__stats_box dashboard__stats_box--denied">
            <h6>Invitaciones Denegadas</h6>
            <br/>
            <p>{{ generalStats.denied }}</p>
          </div>
          <div class="dashboard__stats_box dashboard__stats_box--access">
            <h6>Accesos de Invitación</h6>
            <br/>
            <p>{{ generalStats.invitationAccess }}</p>
          </div>
          <div class="dashboard__stats_box dashboard__stats_box--time">
            <h6>Tiempo promedio de visita</h6>
            <br/>
            <p>{{ generalStats.averageTime }}</p>
          </div>
        </div>
        <div class="dashboard__main_content">
          <router-view></router-view>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import DashboardService from "@/services/DashboardService";
import BuildingIcon from "../../shared/icons/BuildingIcon.vue";
import UsersIcon from "../../shared/icons/UsersIcon.vue";
import CalendarIcon from "../../shared/icons/CalendarIcon.vue";
import CancelIcon from "../../shared/icons/CancelIcon.vue";
import Header from "@/components/shared/Header.vue";
import CompanyService from "@/services/CompanyService";

export default {
  components: {
    BuildingIcon,
    UsersIcon,
    CalendarIcon,
    CancelIcon,
    Header,
  },
  data() {
    return {
      locations: [],
      users: [],
      stats: [],
      generalStats:  null,
      selectedLocation: null,
      selectedUser: null,
      dateRange: null,
    }
  },
  mounted() {
    if (!this.getCompany) {
      this.getCompanyData();
    }
    this.initializeAsync().then(async () => {
      this.setLoader(true);
      await this.getUsers();
      await this.getLocations();
      await this.getGeneralStats();
      this.setLoader(true);
    });
  },
  methods: {
    async initializeAsync() {
      Promise.resolve(resolve => {
        setTimeout(() => resolve(), 10);
      })
    },
    async getGeneralStats() {
      try {
        const startDate = this.getStartDate ? new Date(this.getStartDate) : undefined;
        const endDate = this.getEndDate ? new Date(this.getEndDate) : undefined;
        if (startDate) {
          startDate.setHours(24, 0, 0, 1);
        }
        if (endDate) {
          endDate.setHours(23, 59, 59, 999);
          endDate.setHours(24, 0, 0, 0);
        }
        const params = {
          location_id: this.getLocation || undefined,
          user_id: this.getUser || undefined,
          start_date: startDate,
          end_date: endDate,
        }
        this.generalStats = await DashboardService.getGeneralStats(params);
      } catch(err) {
        console.error(err);
        
      }
    },
    async getUsers() {
      try {
        this.setLoader(true);
        this.users = await DashboardService.getUsers(localStorage.getItem('companyId'));
        this.setLoader(false);
      } catch (e) {
        console.error(e);
      }
    },
    async getLocations() {
      try {
        const data = {company: {id: parseInt(localStorage.getItem('companyId'))}}
        this.locations = await DashboardService.getLocations(this.encrypt(data).toString());
        this.locations[0].name = `${this.getCompany.attributes.name} General`;
      } catch (e) {
        console.error(e);
      }
    },
    async updateSelectedUser() {
      this.$store.commit('setUser', this.selectedUser);
      this.setLoader(true);
      await this.getGeneralStats();
      this.setLoader(false);
    },
    async updateSelectedLocation() {
      this.$store.commit('setLocation', this.selectedLocation);
      
      this.setLoader(true);
      await this.getGeneralStats();
      this.setLoader(false);
    },
    async updateDateRange() {
      this.$store.commit('setRangeDate', {start: this.dateRange.start, end: this.dateRange.end});
      this.setLoader(true);
      await this.getGeneralStats();
      this.setLoader(false);
    },
    async clearDateRange() {
      this.dateRange = null;
      this.$store.commit('setRangeDate', {start: null, end: null});
      this.setLoader(true);
      await this.getGeneralStats();
      this.setLoader(false);
    },
    getCompanyData() {
      this.setLoader(true);
      CompanyService.getCompanyInfo(localStorage.getItem('companyId')).then(async (resp) => {
        this.setCompany(resp.data.data);
        await this.getUsers();
        await this.getLocations();
        await this.getGeneralStats();
        this.setLoader(false);
      }).catch(err => {
        console.error(err);
        this.setLoader(false);
        
      })
    }
  },
}
</script>

<style scoped>

</style>